/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-08-22 14:07:08
 * @version 1.0.0
 */
import kebabCase from 'lodash/kebabCase';

import { TabsMap, NavigatorMap } from '@src/types';
import { TITLE, HOME_NAV_KEY } from './common';

export const HOME_NAV_KEY_ARTICLE = 'article';
export const HOME_NAV_KEY_ASK = 'ask';
export const HOME_TAB_KEY_PRERELEASE = 'preRelease';
export const HOME_TAB_KEY_THEMATIC = 'thematic';

export const HOME_TAB_KEY_FOLLOW = 'follow';
export const HOME_TAB_KEY_LATEST = 'latest';
export const HOME_TAB_KEY_HOT = 'hot';
export const HOME_TAB_KEY_LATEST_QUESTION = 'latestQuestion';
export const HOME_TAB_KEY_LATEST_ANSWER = 'latestAnswer';
export const HOME_TAB_KEY_HOT_QUESTION = 'hotQuestion';
export const HOME_TAB_KEY_VOTE = 'vote';

export const HOME_ANSWER_AGREE_ACTION_TYPE = 'agree';
export const HOME_ANSWER_DISAGREE_ACTION_TYPE = 'disagree';

export const MAX_TAG_LENGTH = 3;

export const ACTIVE_NAV_GROUP = 'group';
export const ACTIVE_NAV_TEAM = 'team';

export const GROUP_MEMBER_MEMBER = 'member';
export const GROUP_MEMBER_REQUIRE = 'require';

export const ACTIVE_GROUP_ALL = 'all';
export const ACTIVE_GROUP_JOINED = 'joined';

// 导航数据
export const NAVIGATOR_MAP: NavigatorMap = {
  defaultActiveKey: HOME_NAV_KEY_ARTICLE,
  data: [
    {
      title: '文章',
      key: HOME_NAV_KEY_ARTICLE,
      path: `/${HOME_NAV_KEY}/${HOME_NAV_KEY_ARTICLE}/${kebabCase(HOME_TAB_KEY_HOT)}`
    },
    {
      title: '问答',
      key: HOME_NAV_KEY_ASK,
      path: `/${HOME_NAV_KEY}/${HOME_NAV_KEY_ASK}/${kebabCase(HOME_TAB_KEY_HOT_QUESTION)}`
    }
  ]
};

// tabs article 数据
export const HOME_TABS_ARTICLE: TabsMap = {
  defaultActiveKey: HOME_TAB_KEY_HOT,
  data: [
    {
      title: '关注',
      index: HOME_TAB_KEY_FOLLOW
    },
    {
      title: '最热',
      index: HOME_TAB_KEY_HOT
    },
    {
      title: '最新',
      index: HOME_TAB_KEY_LATEST
    }
  ]
};

// tabs ask 数据
export const HOME_TABS_ASK: TabsMap = {
  defaultActiveKey: HOME_TAB_KEY_HOT_QUESTION,
  data: [
    {
      title: '关注',
      index: HOME_TAB_KEY_FOLLOW
    },
    {
      title: '最热',
      index: HOME_TAB_KEY_HOT_QUESTION
    },
    {
      title: '最新',
      index: HOME_TAB_KEY_LATEST_QUESTION
    },
    // {
    //   title: '最新回答',
    //   index: HOME_TAB_KEY_LATEST_ANSWER
    // },
    {
      title: '投票',
      index: HOME_TAB_KEY_VOTE
    }
  ]
};

// tabs 数据
export const HOME_TABS_MAP: { [navKey: string]: TabsMap } = {
  [HOME_NAV_KEY_ARTICLE]: HOME_TABS_ARTICLE,
  [HOME_NAV_KEY_ASK]: HOME_TABS_ASK
};

// tab 热门数据
export const HOME_HOT_MAP = {
  [HOME_NAV_KEY_ARTICLE]: {
    title: `${TITLE} 热门文章`
  },
  [HOME_NAV_KEY_ASK]: {
    title: `${TITLE} 热门提问`
  }
};
// 热门圈子和团队切换
export const HOME_ACTIVE_MAP = {
  [ACTIVE_NAV_GROUP]: { title: '圈子' },
  [ACTIVE_NAV_TEAM]: { title: '团队' }
};

export const GROUP_MEMBER_MAP = {
  defaultActiveKey: GROUP_MEMBER_MEMBER,
  data: [
    {
      name: '圈子成员',
      key: GROUP_MEMBER_MEMBER
    },
    {
      name: '请求列表',
      key: GROUP_MEMBER_REQUIRE
    }
  ]
};

/** 活跃圈子 */
export const ACTIVE_GROUP_MAP: TabsMap = {
  defaultActiveKey: ACTIVE_GROUP_ALL,
  data: [
    {
      title: '全部圈子',
      index: ACTIVE_GROUP_ALL
    },
    {
      title: '我加入的',
      index: ACTIVE_GROUP_JOINED
    }
  ]
};
